import React from 'react';
import i18n from '../../i18n';
import getAboutCounts from '../../models/about';


// Mock HomeBanner component
const HomeBanner = ({ callbackForSupport }) => (
    <div className="hero-banner">
        <div className="hero-content">
            <h1 className="hero-title">{i18n.t('about_mzadcom')}</h1>
            {/* <p className="hero-subtitle">Innovating for a Sustainable Future</p> */}
        </div>
    </div>
);


export class About extends React.Component {
    constructor() {
        super();
        this.state = {
            active_buyers: 0,
            active_clients: 0,
            lots_sold: 0,
            auctions: 0,
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.getCounts();
    }

    async getCounts() {
        let response = await getAboutCounts();
        console.log(response);
        if (response.success) {
            let { data } = response;
            this.setState({
                active_buyers: data.active_buyers,
                active_clients: data.active_clients,
                lots_sold: data.lots_sold,
                auctions: data.auctions,
            });
        }
    }

    render() {
        return (
            <React.Fragment>
                <div className="page-container" id="whoweare">
                    <HomeBanner callbackForSupport={this.props.callbackForSupport} />

                    <div className="main-content">
                        <div className="container">
                            {/* Who We Are Section */}
                            <div className="row align-items-center py-5 about-container">
                                <div className="col-lg-6 p-3">
                                    <div className="section-badge">
                                        {i18n.t('whoweare')}
                                    </div>
                                    <div className="content-text">
                                        {i18n.t('who_we_are_text')}
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="text-center">
                                        <img
                                            src="assets/images/about/about_banner.webp"
                                            className="img-fluid feature-image"
                                            alt="About Us"
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Stats Section */}
                            <div className="row">
                                <div className="col-12">
                                    <div className="stats-container">
                                        <div className="stats-header">
                                            <h2 className="stats-title">{i18n.t('our_story_in_number')}</h2>
                                            <p className="stats-subtitle">{i18n.t('our_numbers')}</p>
                                        </div>
                                        <div className="stats-grid">
                                            <div className="stat-item">
                                                <span className="stat-number">{this.state.active_buyers}</span>
                                                <span className="stat-label">{i18n.t('active_buyers')}</span>
                                            </div>
                                            <div className="stat-item">
                                                <span className="stat-number">{this.state.active_clients}</span>
                                                <span className="stat-label">{i18n.t('active_clients')}</span>
                                            </div>
                                            <div className="stat-item">
                                                <span className="stat-number">{this.state.lots_sold}</span>
                                                <span className="stat-label">{i18n.t('lots_sold')}</span>
                                            </div>
                                            <div className="stat-item">
                                                <span className="stat-number">{this.state.auctions}</span>
                                                <span className="stat-label">{i18n.t('auctions')}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Mission & Vision Section */}
                            <div className="mission-vision-section">
                                <div className="row about-container">
                                    <div className="col-lg-6">
                                        <div className="mission-vision-card mission-card">
                                            <div className="section-badge mb-4">
                                                {i18n.t('our_mission')}
                                            </div>
                                            <div className="mission-vision-text">
                                                {i18n.t('our_mission_txt')}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="mission-vision-card vision-card">
                                            <div className="section-badge mb-4">
                                                {i18n.t('our_vision')}
                                            </div>
                                            <div className="mission-vision-text">
                                                {i18n.t('our_vision_txt')}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Services Section */}
                        <div className="services-section">
                            <div className="container">
                                <h2 className="services-title">{i18n.t('offer_best_services')}</h2>
                                <div className="services-grid about-container">
                                    <div className="service-card">
                                        <div className="service-icon">🏛️</div>
                                        <h3 className="service-title">{i18n.t('online_auction')}</h3>
                                        <p className="service-description">{i18n.t('online_auction_text')}</p>
                                    </div>
                                    <div className="service-card">
                                        <div className="service-icon">🗑️</div>
                                        <h3 className="service-title">{i18n.t('waste_management')}</h3>
                                        <p className="service-description">{i18n.t('waste_mgmt_text')}</p>
                                    </div>
                                    <div className="service-card">
                                        <div className="service-icon">♻️</div>
                                        <h3 className="service-title">{i18n.t('recycling')}</h3>
                                        <p className="service-description">{i18n.t('recycling_text')}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Team Section */}
                        {/* <section className="container">
                            <div className="team-section">
                                <div className="container">
                                    <div className="text-center">
                                        <div className="section-badge">
                                            {i18n.t('our_team')}
                                        </div>
                                    </div>
                                    {/* <div className="team-grid">
                                        <div className="team-card">
                                            <img
                                                src="assets/images/about/chairman.jpg"
                                                className="team-image"
                                                alt="Chairman"
                                            />
                                            <div className="team-info">
                                                <h4 className="team-name">{i18n.t('suleym_junaibi')}</h4>
                                                <p className="team-position">{i18n.t('chairman')}</p>
                                            </div>
                                        </div>
                                        <div className="team-card">
                                            <img
                                                src="assets/images/about/ceo.jpg"
                                                className="team-image"
                                                alt="CEO"
                                            />
                                            <div className="team-info">
                                                <h4 className="team-name">{i18n.t('ibrahim_junaibi')}</h4>
                                                <p className="team-position">{i18n.t('ceo')}</p>
                                            </div>
                                        </div>
                                        <div className="team-card">
                                            <img
                                                src="assets/images/about/gm.png"
                                                className="team-image"
                                                alt="GM"
                                            />
                                            <div className="team-info">
                                                <h4 className="team-name">{i18n.t('ahmed_alsaadi')}</h4>
                                                <p className="team-position">{i18n.t('gm')}</p>
                                            </div>
                                        </div>
                                    </div> */}

                                    {/* <div class="card_flex card_flex_secondry mt-5">
                                        <div class="cards  d-flex flex-column rounded-4 bg-light">
                                            <img
                                                src="assets/images/about/chairman.jpg"
                                                height="214"
                                                width="288"
                                                class="card-img-top rounded-4"
                                                alt=""
                                            />
                                            <div class="card-bodys">
                                                <span class="card-text">{i18n.t('suleym_junaibi')}</span>
                                                <br></br>
                                                <span class="card-text_sub">{i18n.t('chairman')}</span>
                                            </div>
                                        </div>
                                        <div class="cards rounded-4 bg-light">
                                            <img
                                                src="assets/images/about/ceo.jpg"
                                                height="214"
                                                width="288"
                                                class="card-img-top rounded-4"
                                                alt=""
                                            />
                                            <div class="card-bodys">
                                                <span class="card-text">{i18n.t('ibrahim_junaibi')}</span>
                                                <br></br>
                                                <span class="card-text_sub">{i18n.t('ceo')}</span>
                                            </div>
                                        </div>
                                        <div class="cards rounded-4 bg-bg-white">
                                            <img
                                                src="assets/images/about/gm.png"
                                                height="214"
                                                width="288"
                                                class="card-img-top"
                                                alt=""
                                            />
                                            <div class="card-bodys bg-light">
                                                <span class="card-text">{i18n.t('ahmed_alsaadi')}</span>
                                                <br></br>
                                                <span class="card-text_sub">{i18n.t('gm')}</span>
                                            </div>
                                        </div>
                                    </div> 
                                </div>
                            </div>
                        </section> */}
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

